import React from 'react';
import { VStack, Alert, AlertIcon, GridItem } from '@chakra-ui/react';
import { useAppContext } from 'src/contexts/AppContext';
import { ChangeClientMenu } from 'src/components/organisms/menus/ChangeClientMenu';
import { DataConnectors } from 'src/components/templates/DataConnectors';

export const ConnectChannelsStep: React.FC = () => {
  const { currentCustomer } = useAppContext();

  if (!currentCustomer) {
    return (
      <GridItem colSpan={14} w="100%">
        <Alert status="warning">
          <AlertIcon />
          Please select a customer to manage data integrations
        </Alert>
      </GridItem>
    );
  }

  return (
    <GridItem colSpan={14} w="100%" pb={{ base: 4, md: 10 }}>
      <VStack spacing={6} align="stretch">
        {/* Header */}
        <ChangeClientMenu />

        {/* Data Connectors - No fetch status in connect step */}
        <DataConnectors showFetchStatus={false} />
      </VStack>
    </GridItem>
  );
};
